import type { AccountantPerformanceInsightsEntity } from "../entities/AccountantStatusEntity";
import type { AccountantStatusRepository } from "../repositories/AccountantStatusRepository";

export class GetAccountantPerformanceInsightsUseCase {
  constructor(private readonly repository: AccountantStatusRepository) {}

  async execute(): Promise<AccountantPerformanceInsightsEntity> {
    return this.repository.getPerformanceInsights();
  }
}
